import { render } from "./UrlListItem.vue?vue&type=template&id=3500b980&ts=true"
import script from "./UrlListItem.vue?vue&type=script&lang=ts"
export * from "./UrlListItem.vue?vue&type=script&lang=ts"

import "./UrlListItem.vue?vue&type=style&index=0&id=3500b980&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__